"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELibraryDeep = void 0;
var ELibraryDeep;
(function (ELibraryDeep) {
  // eslint-disable-next-line id-denylist
  ELibraryDeep[ELibraryDeep["any"] = -1] = "any";
  ELibraryDeep[ELibraryDeep["top"] = 0] = "top";
  ELibraryDeep[ELibraryDeep["single"] = 1] = "single";
  ELibraryDeep[ELibraryDeep["many"] = 1000] = "many";
})(ELibraryDeep = exports.ELibraryDeep || (exports.ELibraryDeep = {}));
